// extracted by mini-css-extract-plugin
module.exports = {"CenteredLoader":"CenteredLoader-module__CenteredLoader___2U-Gl"};